export const TIPOS_RELATORIO = {
  estoque: 1,
  entradas: 2,
  saidas: 3,
  financeiro: 5,
  prestacaoContasEntradas: 6,
  prestacaoContasPatio: 7,
  prestacaoContasSaidas: 8,
  inventario: 9,
  trasnferidosPatioCentral: 10,
  bloqueadosParaLeilao: 11,
  agendamentosPolicia: 12
}



// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/config-tipos-relatorio/tipos-relatorio.js